import { z } from 'zod';
import { isoDateSchema } from './referentials';

// Rapports et exports (BA-055, BA-056, spec 12) : un format commun (colonnes, lignes,
// synthèse) affiché par le portail et exporté en CSV ou XLSX.

export const REPORT_KINDS = [
  'recovery',
  'funnel',
  'scenarios',
  'channels',
  'quality',
  'worklist',
  'consumption',
  'preferredChannels',
] as const;
export type ReportKind = (typeof REPORT_KINDS)[number];

/** Langue des libellés (titres, colonnes, valeurs) : celle du portail. */
export const REPORT_LANGUAGES = ['fr', 'en', 'ar'] as const;
const langSchema = z.enum(REPORT_LANGUAGES).default('fr');

export const reportQuerySchema = z.object({
  from: isoDateSchema,
  to: isoDateSchema,
  insurerId: z.string().optional(),
  productLineId: z.string().optional(),
  agentId: z.string().optional(),
  format: z.enum(['json', 'csv', 'xlsx']).default('json'),
  lang: langSchema,
});

const cell = z.union([z.string(), z.number(), z.null()]);
export const reportSchema = z.object({
  kind: z.enum(REPORT_KINDS),
  title: z.string(),
  period: z.object({ from: z.string(), to: z.string() }),
  columns: z.array(
    z.object({
      key: z.string(),
      label: z.string(),
      type: z.enum(['text', 'number', 'money', 'percent']),
    }),
  ),
  rows: z.array(z.record(z.string(), cell)),
  summary: z.array(
    z.object({
      /** Clé stable de l'indicateur (traduction par le portail). */
      key: z.string().optional(),
      label: z.string(),
      value: cell,
      type: z.enum(['text', 'number', 'money', 'percent']),
      previous: cell.optional(),
    }),
  ),
});
export type Report = z.infer<typeof reportSchema>;

export const EXPORT_KINDS = ['installments', 'payments', 'messages', 'policyholders'] as const;
export const exportQuerySchema = z.object({
  format: z.enum(['csv', 'xlsx']).default('csv'),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
  status: z.string().max(30).optional(),
  insurerId: z.string().optional(),
  lang: langSchema,
});
export const exportFileListSchema = z.object({
  items: z.array(
    z.object({
      id: z.string(),
      kind: z.string(),
      period: z.string().nullable(),
      filename: z.string(),
      contentType: z.string(),
      createdAt: z.string(),
    }),
  ),
});
